export const menuItems = [
    { link: "/uvod", title: "Úvod" },
    { link: "/o-nas", title: "O nás" },
    { link: "/galerie", title: "Galerie" },
    { link: "/kontakt", title: "Kontakt" },
];
